
import Vue from 'vue'
import Loader from '@/components/Loader.vue'
import EmployeesPopup from '@/components/popup/EmployeesPopup.vue'
import DeletePopup from '@/components/popup/DeletePopup.vue'
import { addEmployee, checkEmail, createEmployee, updateEmployee } from '@/connectors/employees'
import { IEmployee, IEmployeeRoles } from '@/types/employees'
import { ModalIds } from '@/components/popup/modal-ids'
import { Endpoints } from '@/connectors/endpoints'
import Employees from '@/pages/settings/Employees.vue'

export default Vue.extend({
  components: { EmployeesPopup, Loader, DeletePopup },
  extends: Employees,
  data () {
    return {
      EndpointAvailableRoles: Endpoints.AVAILABLE_CONTRACTOR_ROLES,
      EndpointDeleteEmployee: Endpoints.DELETE_CONTRACTOR_EMPLOYEE,
      EndpointGetEmployees: Endpoints.GET_CONTRACTOR_EMPLOYEES,
      ModalIds,
      editing: false,
      loader: false,
      emailAvailable: true,
      selected: [] as string[],
      roles: [] as IEmployeeRoles[],
      employees: [] as IEmployee[],
      employee: {
        roles: [] as string[]
      },
      currentElementId: '',
      isDisabled: false
    }
  },
  computed: {
    idSelectedOrganization (): number {
      return this.$store.state.profile.currentOrganization.id
    }
  },
  methods: {
    // Проверка почты и создание сотрудника
    createEmployee (employee, selected) {
      this.isDisabled = true
      checkEmail(employee.email, Endpoints.CHECK_CONTRACTOR_EMAIL)
        .then(res => {
          if (res.data.email_available) {
            this.emailAvailable = true
            employee.cid = this.idSelectedOrganization
            employee.roles = selected.map(role => role.name)
            createEmployee(employee, Endpoints.CREATE_CONTRACTOR_EMPLOYEE)
              .then(() => {
                // @ts-ignore
                this.pullEmployees()
              }).catch(e => {
                console.error(e.response)
                // @ts-ignore
                this.$showErrorToast(e.response.data.message)
              })
          } else {
            // @ts-ignore
            this.$showSuccessToast('Сотрудник создан успешно')
            this.emailAvailable = false
          }
          this.isDisabled = false
        }).catch(e => {
          this.isDisabled = false
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    // Добавление зарегистрированного сотрудника
    addEmployee (employee, selected) {
      employee.cid = this.idSelectedOrganization
      employee.roles = selected.map(role => role.name)
      addEmployee(employee, Endpoints.ADD_CONTRACTOR_EMPLOYEE)
        .then(() => {
          this.emailAvailable = true
          // @ts-ignore
          this.pullEmployees()
          // @ts-ignore
        }).catch(e => {
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    updateEmployee (employee, selected) {
      this.isDisabled = true
      console.log('updateEmployee')
      employee.cid = this.idSelectedOrganization
      employee.roles = selected.map(role => role.name)
      updateEmployee(employee.id, employee, Endpoints.UPDATE_CONTRACTOR_EMPLOYEE)
        .then(() => {
          // @ts-ignore
          this.pullEmployees()
          this.isDisabled = false
          // @ts-ignore
          this.$showSuccessToast('Сотрудник обновлен успешно')
        }).catch(e => {
          console.error(e.response)
          this.isDisabled = false
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    }
  }
})
